import { userAddressesNode } from '@/api/firebase'
import { firebaseObjectToArray } from '@/utils'
import { async, GET_ASYNC, ASYNC_MUTATIONS } from '@/utils/async'

const state = {
    userAddresses: false,
    userAddress: false,
    ...async()
}

const getters = {
    GET_USER_ADDRESSES: (state) => firebaseObjectToArray(state.userAddresses),
    GET_USER_ADDRESS: (state) => firebaseObjectToArray(state.userAddress),
    GET_ASYNC
}

const mutations = {
    SET_USER_ADDRESSES(state, payload) {
        state.userAddresses = payload
    },
    SET_USER_ADDRESS(state, payload) {
        state.userAddress = payload
    },
    CLEAR_USER_ADDRESSES(state) {
        state.userAddresses = false
    },
    CLEAR_USER_ADDRESS(state) {
        state.userAddress = false
    },
    ...ASYNC_MUTATIONS()
}

const actions = {
    // =================================== C/U/D Operations ===================================

    // =================================== Read Operations ===================================

    /**
     * FETCH_USER_ADDRESSES_BY_ID
     *
     *     Retrieve a list of addresses by user id. If empty, set false. Binds a firebase connection.
     *
     * @param payload.id {string} - The id of the store userAddress to retrieve.
     * @returns {Void}
     */
    FETCH_USER_ADDRESSES_BY_ID({ commit }, payload) {
        commit('REQUEST')
        commit('CLEAR_USER_ADDRESSES')
        userAddressesNode.child(payload.id).on(
            'value',
            function(data) {
                try {
                    commit('SET_USER_ADDRESSES', data.val() || false)
                    commit('SUCCESS')
                } catch (err) {
                    commit('ERROR', err.message)
                }
            },
            function(err) {
                commit('ERROR', err.message)
            }
        )
    },

    // =================================== Listener Operations ===================================

    /**
     * REMOVE_USER_ADDRESSES_REFERENCE
     *
     *     Unbind a firebase connection on a child that was set.
     *
     * @param payload.id {string} - The id of the user child.
     */
    REMOVE_USER_ADDRESSES_REFERENCE({ commit }, payload) {
        commit('CLEAR')
        commit('CLEAR_USER_ADDRESS')
        userAddressesNode.child(payload.id).off()
    }
}

export { state, getters, mutations, actions }
